import React from 'react';
import styled from 'styled-components';
import SpanPrice from '../price/SpanPrice';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';
import * as F from '../../../lib/util/CommonFunctions';

const ProdItemBlock = styled.li`
    //float: left;
    //width: 25%;
    //height: 386px;
    width:${isMobileOnly?"44vw":"25%"};
    padding-left: ${isMobileOnly?"0":"28px"};
    //margin-top: 40px;
    margin-bottom: 40px;
`;

const ProdItemPBlock = styled.p`
    margin-bottom: 20px;    
    ${!isMobileOnly&&"min-height: 271.5px"};
    cursor: pointer;
    line-height : ${isMobileOnly?"44vw":"273px"};
`;

const ProdListItemImg = styled.img`
    border-radius: 4px;
    ${isMobileOnly?`
      width:44vw;
      max-height:44vw;
      // height:44vw;
    `:`
        min-width: 100%; 
        min-height: 100%;    
    `};
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
    ${!isMobileOnly&&"max-height: 273px"};
    ${!isMobileOnly&&"max-width : 273px"};
    vertical-align : middle;
    object-fit: cover;
`;

const ProdItemTitlePBlock = styled.p`
    ${isMobileOnly?`
      max-height:  2.8em;
      text-overflow: ellipsis;
      overflow: hidden;
    `:`
      max-height: 38px
    `};
    line-height: 1.4;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    cursor: pointer;
`;

const ProdItemBrandSpanBlock = styled.span`
    display: ${props => props.display};
    margin-bottom: 10px;
    font-size: ${isMobileOnly?"12px":"14px"};
    font-weight: 500;
    cursor: pointer;
    ${isMobileOnly&&"color:#999999;"}
`;

const ProdItem = ({ img, prodname, sale_price, prdct_price,
    brandname, isBrandShow, prodinfo, clickHandler, brandid }) => {

    const [value, setValue] = useState(prodinfo);

    const handleClick = () => {
        if(clickHandler!== null && clickHandler !==undefined) {
            clickHandler(value);
        }
        
    }

    // console.log("brandname : " + brandname);
    return (
        <ProdItemBlock >
            <ProdItemPBlock >
                <Link to={"/prod?prodid="+prodinfo.prdct_id}>
                <ProdListItemImg src={img} />
                </Link>
            </ProdItemPBlock>
            <ProdItemBrandSpanBlock display={isBrandShow ? 'block' : 'none'}>
                <Link to={"/brHome/" + brandid}>{brandname}</Link>
            </ProdItemBrandSpanBlock>
            <ProdItemTitlePBlock >
                <Link to={"/prod?prodid="+prodinfo.prdct_id}>
                {prodname}
                </Link>
            </ProdItemTitlePBlock>
            {/*<SpanPrice value={sale_price} fontSize={isMobileOnly?"16px":"18px"} isSale={false} onClick={handleClick} />*/}
            <div >
                <Link to={"/prod?prodid="+prodinfo.prdct_id}>
            {F.showAmount({
              prefix: "견적시작가 ",
              pfFontSize: "12px",
              pfWeight: "400",
              fontSize: isMobileOnly?"16px":"18px",
              amount: sale_price,
              weight: "500",
              color: "#111",
              unit:""

            })}
                </Link>
            </div>
            {/*{*/}
            {/*    sale_price === prdct_price ? '' :*/}
            {/*        <SpanPrice fontSize={isMobileOnly?"14px":"18px"} value={prdct_price} isSale={true} />*/}
            {/*        */}
            {/*}*/}
        </ProdItemBlock>
    );
};

export default ProdItem;
